<template>
  <div class="authc-ent account-page">
    <div class="header">
      <span class="back-btn" type="text" @click="$router.go(-1)">&lt;&lt;返回</span>
      <span class="title">企业实名认证</span>
    </div>
	<el-steps :active="step" align-center process-status="finish" finish-status="success" class="authc-steps">
	  <el-step title="认证信息"></el-step>
	  <el-step title="信息审核"></el-step>
	  <el-step title="认证完成"></el-step>
	</el-steps>
	<!-- <el-form ref="form" :inline="true" :model="form" label-width="80px" class="form">
		<el-form-item label="企业名称">
			<el-input v-model="form.name"></el-input>
		</el-form-item>
		<el-form-item label="企业证件号">
			<el-input v-model="form.name"></el-input>
		</el-form-item>
	</el-form> -->
	<div v-if="(step === 1) || ($store.state.userAuth==10&&step==3)" class="content">
		<div class="form">
			<div class="license-nav">
				<div class="license-word-nav">
					<div class="form-item">
						<div class="form-label">
							<div>企业名</div>
						</div>
						<div>
							<el-input v-model="form.name" placeholder="请输入企业名称" @blur="verifyName"></el-input>
						</div>
						<div class="form-error">{{errors.name}}</div>
					</div>
					<div class="form-item form-item-last">
						<div class="form-label">
							<div>企业证件号</div>
						</div>
						<div>
							<el-input v-model="form.code" placeholder="请输入企业证件号" @blur="verifyCode"></el-input>
						</div>
						<div class="form-error">{{errors.code}}</div>
					</div>
				</div>
				<div class="license-photo-nav form-item">
					<div class="form-label">
						<div>企业证件照</div>
					</div>
					<div class="upload-photo" @click="choseFile('file0')" style="margin-right: 180px;">
						<!-- <div v-if="form.photo1 === ''"> -->
						<input type="file"  name="file0" id="file0" style="display:none;" @change="upload('file0')"/>
						<img class="license-photo" :src="form.photo1url" alt="">
					</div>
				</div>
			</div>
			<div class="authentication-main">
				<div class="formItem">
					<div class="form-label">
						<div>认证类型</div>
					</div>
					<div>
						<el-radio v-model="form.auth_type" label="1">法人认证</el-radio>
						<el-radio v-model="form.auth_type" label="2">授权认证</el-radio>
					</div>
				</div>
				<div v-if="form.auth_type === '1'">
					<div class="legalPerson">
						<div class="form-item">
							<div  class="form-label">
								<div>法人代表姓名</div>
							</div>
							<div>
								<el-input v-model="form.user_name" placeholder="请输入法人代表姓名" @blur="verifyUserName"></el-input>
							</div>
							<div class="form-error">{{errors.user_name}}</div>
						</div>
						<div class="form-item form-item-last">
							<div class="form-label">
								<div>法人代表身份证号</div>
							</div>
							<div>
								<el-input v-model="form.user_id_card" maxlength="18" placeholder="请输入法人代表身份证号" @blur="verifyIDcard"></el-input>
							</div>
							<div class="form-error">{{errors.user_id_card}}</div>
						</div>
					</div>
				</div>
				<div v-if="form.auth_type === '2'">
					<div class="empower-nav">
						<div class="form-item">
							<div  class="form-label">
								<div>授权人姓名</div>
							</div>
							<div>
								<el-input v-model="form.user_name" placeholder="请输入授权人姓名" @blur="verifyUserName"></el-input>
							</div>
							<div class="form-error">{{errors.user_name}}</div>
						</div>
						<div class="form-item form-item-last">
							<div class="form-label">
								<div>授权人身份证号</div>
							</div>
							<div>
								<el-input v-model="form.user_id_card" maxlength="18" placeholder="请输入授权人代表身份证号" @blur="verifyIDcard"></el-input>
							</div>
							<div class="form-error">{{errors.user_id_card}}</div>
						</div>
					</div>
				</div>
				<div class="authentication-main-photo-nav">
					<div class="mainPhoto">
						<div class="form-label">
							<div>身份证件</div>
						</div>
						<div>
							<div class="authentication-main-photo upload-photo" @click="choseFile('file2')">
								<img class="idcard" :src="form.user_photo1url" alt="">
								<input type="file" name="file2" id="file2" style="display:none;" @change="upload('file2')"/>
							</div>
							<div class="authentication-main-photo upload-photo"  @click="choseFile('file3')">
								<img class="idcard" :src="form.user_photo2url" alt="">
								<input type="file" name="file3" id="file3" style="display:none;" @change="upload('file3')"/>
							</div>
						</div>
					</div>
					<div class="mainPhoto" v-if="form.auth_type === '2'">
						<div class="form-label">
							<div>授权书</div>
						</div>
						<div>
							<div class="upload-photo"  @click="choseFile('file1')">
								<div>
								<!-- <div v-if="form.photo2 === ''"> -->
									<img class="empower-photo" :src="form.photo2url" alt="">
									<input type="file"  name="file1" id="file1" style="display:none;" @change="upload('file1')"/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div>
			<el-button type="primary" @click="onSubmit">立即认证</el-button>
			<!-- <el-button>重置</el-button> -->
		</div>
	</div>
	<div v-if="step === 2" class="content">
		<div class="examine">
			<img class="" src="../../assets/icon/authing.png" style="width: 200px;" alt="">
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    name: 'Ent',
	data() {
	  return {
		  auth: 1,
		step: 1,
		errors: {
		  name: '',
		  code: '',
		  user_name: '',
		  user_id_card: '',
		},
		verifyNameFlag: false,
		verifyCodeFlag: false,
		verifyUserNameFlag: false,
		verifyIDcardFlag: false,
		form: {
			name: '',
			code: '',
			auth_type: '1',
			photo1: '',
			photo2: '',
			photo1url: 'https://dingdong-public.oss-cn-hangzhou.aliyuncs.com/uum/imgs/20200806/970fb84602ee82b53dd01de9b3fce6d4.png',
			photo2url: 'https://dingdong-public.oss-cn-hangzhou.aliyuncs.com/uum/imgs/20200806/970fb84602ee82b53dd01de9b3fce6d4.png',
			user_name: '',
			user_id_card: '',
			user_photo1: '',
			user_photo2: '',
			user_photo1url: 'https://dingdong-public.oss-cn-hangzhou.aliyuncs.com/uum/imgs/20200806/36a97337b1e2742b51b59e9e8c996fdf.png',
			user_photo2url: 'https://dingdong-public.oss-cn-hangzhou.aliyuncs.com/uum/imgs/20200806/66d53412d6b83ba0680d905e3033bc1b.png',
			type: '1',
		}
	  }
	},
	methods: {
		verifyName (event) {
				  if (this.form.name === ''){
					  this.verifyNameFlag = false
					  console.log('企业名称不能为空')
					  this.errors['name'] = '企业名称不能为空'
					  // console.log(this.verifyCodeFlag)
				  } else {
					  this.verifyNameFlag = true
					  this.errors['name'] = ''
				  }
		},
		verifyCode (event) {
				  if (this.form.code === ''){
					  this.verifyCodeFlag = false
					  console.log('企业证件号不能为空')
					  this.errors['code'] = '企业证件号不能为空'
				  } else {
					  this.verifyCodeFlag = true
					  this.errors['code'] = ''
				  }
		},
		verifyUserName (event) {
			if(this.form.auth_type==1){
				if (this.form.user_name === ''){
					  this.verifyUserNameFlag = false
					  console.log('企业法人代表不能为空')
					  this.errors['user_name'] = '企业法人代表不能为空'
				  } else {
					  this.verifyUserNameFlag = true
					  this.errors['user_name'] = ''
				  }
			} else {
				if (this.form.user_name === ''){
					  this.verifyUserNameFlag = false
					  console.log('企业授权人不能为空')
					  this.errors['user_name'] = '企业授权人不能为空'
				  } else {
					  this.verifyUserNameFlag = true
					  this.errors['user_name'] = ''
				  }
			}
				  
		},
		verifyIDcard (event) {
			if (this.form.user_id_card === '') {
				this.verifyIDcardFlag = false
				console.log('身份证号码不能为空')
				this.errors['user_id_card'] = '身份证号码不能为空'
			} else {
				let reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/
				if (!reg.test(this.form.user_id_card)) {
					this.errors['user_id_card'] = '身份证号码不正确'
					this.verifyIDcardFlag = false
				} else {
					this.verifyIDcardFlag = true
					this.errors['user_id_card'] = ''
				}
			}
		},
		onSubmit() {
			this.verifyName()
			this.verifyCode()
			this.verifyUserName()
			this.verifyIDcard()
			if (this.verifyNameFlag === true && this.verifyCodeFlag === true && this.verifyUserNameFlag === true && this.verifyIDcardFlag === true) {
				this.$msgbox.confirm('请确认填写信息无误后提交?', '提交', {
				confirmButtonText: '提交',
				cancelButtonText: '取消',
				type: 'warning',
				center: true
			}).then(() => {
				this.$api.user.authEnt(this.form.name, this.form.code, this.form.auth_type, this.form.photo1, this.form.photo2, this.form.user_name, this.form.user_id_card, this.form.user_photo1, this.form.user_photo2, this.form.type).then(res => {
					console.log(res)
					if (res.code === 0){
						this.$message({
							type: 'success',
							message: '提交成功!'
						});
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消提交'
				});
			});
			} else {
				console.log('error')
			}
			console.log('submit!')
		},
		choseFile(id) {
			console.log(id);
			var f = document.getElementById(id);
			f.click();
			console.log('submit!');
		},
		upload(id) {
			var chosefile = document.getElementById(id).files[0]
			console.log(chosefile)
			this.$api.user.resPrivate(chosefile, 1).then(res => {
				console.log(res)
				switch (id) {
					case ('file0') :
						this.form.photo1 = res.data.id
						this.form.photo1url = res.data.url
						break
					case ('file1') :
						this.form.photo2 = res.data.id
						this.form.photo2url = res.data.url
						break
					case ('file2') :
						this.form.user_photo1 = res.data.id
						this.form.user_photo1url = res.data.url
						break
					case ('file3') :
						this.form.user_photo2 = res.data.id
						this.form.user_photo2url = res.data.url
						break
				}
			  // 1030 formKey过期 1012 验证码错误
			  // if (res.code === 0) {
			  //   this.smsError = ''
			  // } else {
			  //   this.smsError = res.msg
			  // }
			})
		},
		getAuthAudit() {
			//获取认证状态 0 未认证 1 认证中 2 认证未通过退回第一步重新填写提交 3 认证通过
			this.$api.user.getAuthAudit().then(res => {
				console.log(res)
				if (res.code === 0) {
					switch (res.data.status) {
						case (0) :
							this.step = 1
							break
						case (1) :
							this.step = 2
							break
						case (2) :
							this.step = 1
							this.$msgbox({
								title: '审核未通过',
								message: res.data.msg,
								confirmButtonText: '重新提交',
								type: 'warning',
								center: true
							})
							this.$api.user.getAuthInfo().then(res => {
								console.log(res)
								if (res.code === 0){
									this.form.name = res.data.EntName
									this.form.code = res.data.EntCode
									this.form.photo1 = res.data.EntPhoto1
									this.form.photo2 = res.data.EntPhoto2
									this.form.auth_type = res.data.AuthType
									this.form.user_name = res.data.UserName
									this.form.user_id_card = res.data.UserCode
									this.form.user_photo1 = res.data.UserPhoto1
									this.form.user_photo2 = res.data.UserPhoto2
									this.$api.user.getResource (res.data.EntPhoto1).then(res => {
										 this.form.photo1url = res.data.url
									})
									this.$api.user.getResource (res.data.EntPhoto2).then(res => {
										 this.form.photo2url = res.data.url
									})
									this.$api.user.getResource (res.data.UserPhoto1).then(res => {
										 this.form.user_photo1url = res.data.url
									})
									this.$api.user.getResource (res.data.UserPhoto2).then(res => {
										 this.form.user_photo2url = res.data.url
									})
								}
							})
							// this.$msgbox.confirm({{res.data.msg}}, '审核未通过', {
							// 	confirmButtonText: '重新提交',
							// 	cancelButtonText: '取消',
							// 	type: 'warning',
							// 	center: true
							// })
							break
						case (3) :
							this.step = 3
							break
					}
				}
			})
		}
	},
	created() {
		this.getAuthAudit()
	}
  }
</script>

<style scoped>
.authc-steps {
    margin-top: 40px;
  }
.content{
	margin: 50px 200px;
}
  .form {
	width: 800px;
  }
  .formItem{
	  width: 300px;
	  /* margin-bottom: 20px; */
  }
  .form-error{
	  color: red;
  }
  .form-item{
	  width: 300px;
	  /* margin-bottom: 20px; */
	  float: left;
  }
  .form-item-last{
	  float: right;
  }
  .form-label {
	  font-size: 16px;
	  margin-bottom: 8px;
  }
  .license-nav {
	  height: 300px;
  }
  .license-word-nav {
	  height: 90px;
	  /* margin-right: 50px; */

  }
  .license-photo-nav {

	  
  }
  .license-photo{
	  width: 120px;
  }
  .legalPerson {
	  height: 90px;
  }
  .empower-nav{
	  height: 90px;
  }
  .empower-photo-nav{
	  margin-right: 50px;
	  margin-bottom: 0;
	  float: right;
  }
  .empower-photo{
	  width: 120px;
  }
  .upload-photo{
	  cursor: pointer;
  }
  .authentication-main-photo-nav{
	  height: 250px;
  }
  .authentication-main-photo {
	  margin-right: 40px;
	  float: left;
  }
  .mainPhoto {
	  float: left;
  }
  .idcard{
	  width: 240px;
  }
  .examine{
  	  width: 200px;
  	  margin: 20px auto;
  }
</style>
